import React from "react";

const Stat_Sample_Types = () => {
  return (
    <div>
      <h1>Stat Sample Types</h1>
    </div>
  );
};

export default Stat_Sample_Types;
